import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import type {
	IContext,
	PineJS,
	StudyMetaInfo,
} from "@/charting_library/charting_library";
import type { IReadAllParams } from "@/services/RequestParams";
import { chartColors } from "../../../const";
import type { IndicatorsService } from "./getIndicatorsService";

export const getDefaultParams = (from: number, to: number, ticker: string) =>
	({
		filter: [
			{
				name: "date",
				condition: "gte",
				value: from,
			},
			{
				name: "date",
				condition: "lt",
				value: to,
			},
			{
				name: "ticker",
				condition: "eq",
				value: ticker,
			},
		],
		sort: [{ name: "date", order: 1 }],
	}) as Readonly<IReadAllParams>;

export const getSlopeColorId = (slope: number): number => {
	return slope > 0 ? 2 : slope < 0 ? 0 : 1;
};

export const defaultHistogramColors = {
	0: {
		color: chartColors.down,
		width: 5,
		style: 0,
	},
	1: {
		color: chartColors.consolidation,
		width: 5,
		style: 0,
	},
	2: {
		color: chartColors.up,
		width: 5,
		style: 0,
	},
} as const;

export const defaultColorNames = {
	0: {
		name: "Down color",
	},
	1: {
		name: "Consolidation color",
	},
	2: {
		name: "Up color",
	},
} as const;

export abstract class CustomIndicatorService<T> implements IndicatorsService {
	abstract fieldMapper(item: T): PriceInfo<UTCTimestamp>;
	abstract getBarData(
		from: number,
		to: number,
		interval: string,
		ticker: string,
	): Promise<PriceInfo<UTCTimestamp>[]>;
	abstract getPlotsData(PineJS: PineJS, context: IContext): number[];
	abstract get styles(): StudyMetaInfo["styles"];

	get plots(): StudyMetaInfo["plots"] {
		return [
			{
				id: "plot_0",
				type: "line",
			},
			{
				id: "plot_1",
				type: "line",
			},
		] as StudyMetaInfo["plots"];
	}

	get defaults(): StudyMetaInfo["defaults"] {
		return {
			styles: {
				plot_0: {
					plottype: 0,
					linestyle: 0,
					visible: true,
					transparency: 0,
					color: "#FF0000",
				},
				plot_1: {
					plottype: 0,
					linestyle: 0,
					visible: true,
					transparency: 0,
				},
			},
		};
	}

	get palettes(): StudyMetaInfo["palettes"] {
		return {};
	}
}
